// Import constants
const { formatCurrency } = require('../../constants.js');

// Define component
const SingleRug = {
    name: 'SingleRug',
    props: {
        size: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { computed } = Vue;
        const { useStore } = Vuex;

        const store = useStore();

        return {
            store,
            formatCurrency
        };
    },
    template: `
        <div class="single-size-option" :class="{                           
                'bg-shades-100': size.rug_sku === store.state.selectedSize?.rug_sku
            }">
            <div> 
                <div class="mb-1 text-sm font-bold leading-none text-shades-800">
                    {{ size.rug_width }}cm x {{ size.rug_length }}cm {{ size.rug_variable_title }}
                </div>
                <div class="mb-1 text-xs text-brand-600" v-if="size.rug_stock <= 3">
                    Hurry only {{ size.rug_stock }} remaining
                </div>
                <div class="single-option-delivery">
                    <svg class="fill-shades-600" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 640 512">
                        <path d="M640 0l0 400c0 61.9-50.1 112-112 112c-61.6 0-111.6-49.8-112-111.3L48.6 502.8l-30.8 8.6L.6 449.7l30.8-8.6L352 352.1 352 0 640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM14.8 176.8l77.3-20.7 24.8 92.7 61.8-16.6-24.8-92.7 77.3-20.7 58 216.4-216.4 58-58-216.4z" />
                    </svg>
                    <span>Free Delivery from 24th February</span>
                </div>
            </div>
            <div class="text-right">
                <div class="font-semibold text-brand-500">
                    {{ formatCurrency(size.rug_sale_price || size.rug_default_price) }}
                </div>
                <div v-if="size.rug_sale_price" class="text-sm line-through text-shades-500">
                    {{ formatCurrency(size.rug_default_price) }}
                </div>
            </div>
        </div>
    `
};

// Export the component using module.exports
module.exports = { SingleRug };
